<script lang="ts" setup>
let timerInterval: ReturnType<typeof setInterval> | null = null;

const { template } = storeToRefs(useTemplateStore());
const timeLeft = ref(0);

const formattedEventDate = computed(() => {
  return template.value.general.date
    ? new Date(template.value.general.date).toLocaleDateString("id-ID", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }).toUpperCase()
    : "";
});

const diffInDays = computed(() => {
  return Math.floor(timeLeft.value / (24 * 60 * 60));
});

const diffInHours = computed(() => {
  return Math.floor((timeLeft.value % (24 * 60 * 60)) / (60 * 60));
});

const diffInMinutes = computed(() => {
  return Math.floor((timeLeft.value % (60 * 60)) / 60);
});

const diffInSeconds = computed(() => {
  return timeLeft.value % 60;
});

const countdownTime = computed(() => {
  return [
    {
      label: "HARI",
      value: diffInDays.value,
    },
    {
      label: "JAM",
      value: diffInHours.value,
    },
    {
      label: "MENIT",
      value: diffInMinutes.value,
    },
    {
      label: "DETIK",
      value: diffInSeconds.value,
    },
  ];
});

async function calculateTimeLeft() {
  const date = new Date(template.value.general.date);
  const currentDate = new Date();
  const diffInSeconds = Math.floor((date.getTime() - currentDate.getTime()) / 1000);

  timeLeft.value = diffInSeconds > 0 ? diffInSeconds : 0;
};

onMounted(async () => {
  await calculateTimeLeft(); // Initial calculation

  timerInterval = setInterval(calculateTimeLeft, 1000);
});

onUnmounted(() => {
  if (timerInterval !== null) {
    clearInterval(timerInterval);
  }
});
</script>

<template>
  <section
    id="date"
    class="relative overflow-clip min-h-[235px] bg-white shadow-lg py-14 px-12 text-center flex flex-col gap-6 md:gap-8"
  >
    <!-- Flower Decoration -->
    <NuxtImg
      src="/date-flower.webp"
      alt="Flower Decoration"
      class="absolute bottom-0 left-0 pointer-events-none w-[120px] h-auto xs:w-[150px] md:w-3xs"
      decoding="async"
      loading="lazy"
      fetchpriority="auto"
      :preload="{
        fetchPriority: 'auto',
      }"
    />

    <!-- Glitters Decoration -->
    <NuxtImg
      src="/events-glitter-desktop.webp"
      alt="Glitters Decoration"
      class="absolute -top-[26%] left-[20%] pointer-events-none w-auto h-auto rotate-270 opacity-30 md:left-[35] md:top-0"
      decoding="async"
      loading="lazy"
      fetchpriority="auto"
      :preload="{
        fetchPriority: 'auto',
      }"
    />

    <NuxtImg
      src="/events-glitter-desktop.webp"
      alt="Glitters Decoration"
      class="absolute -bottom-[26%] right-[20%] pointer-events-none w-auto h-auto rotate-90 opacity-30 md:left-[35] md:top-0"
      decoding="async"
      loading="lazy"
      fetchpriority="auto"
      :preload="{
        fetchPriority: 'auto',
      }"
    />

    <!-- Content -->
    <div class="flex flex-col gap-6 size-full z-1 md:gap-8">
      <time
        class="text-xl text-default whitespace-nowrap sm:text-2xl md:text-4xl md:text-[32px]"
        data-aos="zoom-in"
        data-aos-delay="200"
        :datetime="template.general.date"
      >
        {{ formattedEventDate }}
      </time>
      <ul
        id="countdown-timer"
        class="grid auto-cols-max grid-flow-col gap-3 items-center justify-center"
      >
        <li
          v-for="(value, index) in countdownTime"
          :key="value.label"
          class="px-6 py-4.5 flex flex-col items-center justify-center text-center gap-1.5 rounded-md bg-primary-100 text-primary-800  w-16 md:w-24"
          data-aos="flip-down"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="600"
          data-aos-offset="200"
          data-aos-anchor="#countdown-timer"
          :data-aos-delay="300 + (index * 100)"
        >
          <span
            class="text-xl xs:text-2xl font-medium"
          >
            {{ value.value }}
          </span>
          <span
            class="text-xs text-default"
          >
            {{ value.label }}
          </span>
        </li>
      </ul>
    </div>
  </section>
</template>
